export default function CommercialStrategyPage() {
  return (
    <div className="min-h-screen bg-white font-playfair">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div className="flex items-center justify-center w-full md:w-auto">
              <h1>
                <a href="/">
                  <img 
                    src="https://static.readdy.ai/image/a19705f045df358eda503236ce656b36/846ee1e93f81f94b53dc3e9fa39ac791.png" 
                    alt="VTC Legal - Fractional General Counsel for AI and Tech Companies" 
                    className="h-16 w-auto"
                  />
                </a>
              </h1>
            </div>
            
            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-10">
              <a href="/#services" className="text-gray-900 hover:text-teal-600 font-medium tracking-wide transition-colors">Services</a>
              <a href="/#why-vtc" className="text-gray-900 hover:text-teal-600 font-medium tracking-wide transition-colors">Why VTC</a>
              <a href="/#how-it-works" className="text-gray-900 hover:text-teal-600 font-medium tracking-wide transition-colors">How It Works</a>
              <a href="/#contact" className="bg-black text-white px-8 py-3 rounded-md hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer font-medium">Get Started</a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="bg-white py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-5xl font-bold text-gray-900 mb-8 font-playfair">
            Commercial Strategy
          </h2>
          <p className="text-xl text-gray-700 mb-12 max-w-3xl mx-auto leading-relaxed font-inter">
            Strategic contract negotiation and commercial structuring that protects your interests while accelerating growth and market expansion.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-16">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-8 font-playfair">Strategic Advantage</h3>
              <div className="space-y-6">
                <p className="text-gray-700 leading-relaxed font-inter">
                  Commercial agreements are the foundation of business growth. Poor contract terms can limit scalability, create hidden liabilities, and block strategic opportunities.
                </p>
                <p className="text-gray-700 leading-relaxed font-inter">
                  Our commercial strategy approach focuses on deal structures that enable long-term success rather than just getting deals done quickly.
                </p>
              </div>
            </div>

            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-8 font-playfair">Proven Experience</h3>
              <div className="space-y-6">
                <p className="text-gray-700 leading-relaxed font-inter">
                  Having served as Legal Director at high-growth SaaS companies, I understand the commercial realities of technology businesses and the deal terms that matter most.
                </p>
                <p className="text-gray-700 leading-relaxed font-inter">
                  We negotiate from a position of strength, understanding both legal risk and business impact to achieve optimal outcomes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contract Types */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h3 className="text-4xl font-bold text-gray-900 mb-16 text-center font-playfair">Commercial Agreement Expertise</h3>
          
          <div className="grid md:grid-cols-2 gap-12">
            <div className="space-y-8">
              <div className="bg-gray-50 p-8 rounded-lg">
                <div className="w-12 h-12 bg-gray-900 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-building-line text-white text-xl"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-4 font-playfair">Enterprise SaaS Agreements</h4>
                <p className="text-gray-700 font-inter mb-4">
                  Master service agreements, subscription terms, and enterprise license deals that scale from startup to IPO.
                </p>
                <ul className="text-gray-600 space-y-2 text-sm font-inter">
                  <li>• Usage-based pricing models</li>
                  <li>• Service level agreements</li>
                  <li>• Data processing addendums</li>
                  <li>• Professional services terms</li>
                </ul>
              </div>

              <div className="bg-gray-50 p-8 rounded-lg">
                <div className="w-12 h-12 bg-gray-900 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-links-line text-white text-xl"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-4 font-playfair">Strategic Partnerships</h4>
                <p className="text-gray-700 font-inter mb-4">
                  Joint ventures, technology partnerships, and channel agreements that drive mutual growth.
                </p>
                <ul className="text-gray-600 space-y-2 text-sm font-inter">
                  <li>• Revenue sharing models</li>
                  <li>• Integration partnerships</li>
                  <li>• Reseller agreements</li>
                  <li>• Technology licensing</li>
                </ul>
              </div>
            </div>

            <div className="space-y-8">
              <div className="bg-gray-50 p-8 rounded-lg">
                <div className="w-12 h-12 bg-gray-900 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-shopping-cart-line text-white text-xl"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-4 font-playfair">Vendor & Procurement</h4>
                <p className="text-gray-700 font-inter mb-4">
                  Technology vendor agreements, cloud services contracts, and strategic supplier relationships.
                </p>
                <ul className="text-gray-600 space-y-2 text-sm font-inter">
                  <li>• Cloud service agreements</li>
                  <li>• Software licensing deals</li>
                  <li>• Data processing contracts</li>
                  <li>• Professional services</li>
                </ul>
              </div>

              <div className="bg-gray-50 p-8 rounded-lg">
                <div className="w-12 h-12 bg-gray-900 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-lightbulb-line text-white text-xl"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-4 font-playfair">IP & Licensing</h4>
                <p className="text-gray-700 font-inter mb-4">
                  Intellectual property licensing, technology transfer, and complex IP arrangements.
                </p>
                <ul className="text-gray-600 space-y-2 text-sm font-inter">
                  <li>• Software licensing models</li>
                  <li>• Patent licensing agreements</li>
                  <li>• Open source compliance</li>
                  <li>• Trade secret protection</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Negotiation Approach */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h3 className="text-4xl font-bold text-gray-900 mb-12 text-center font-playfair">Strategic Negotiation Process</h3>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-8">
                <span className="text-white text-2xl font-bold font-inter">1</span>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4 font-playfair">Business Analysis</h4>
              <p className="text-gray-700 font-inter">
                Deep dive into your business model, growth objectives, and risk tolerance to inform negotiation strategy.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-8">
                <span className="text-white text-2xl font-bold font-inter">2</span>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4 font-playfair">Risk Assessment</h4>
              <p className="text-gray-700 font-inter">
                Comprehensive review of proposed terms, identifying hidden risks and structural issues before negotiation begins.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-8">
                <span className="text-white text-2xl font-bold font-inter">3</span>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4 font-playfair">Strategic Execution</h4>
              <p className="text-gray-700 font-inter">
                Collaborative negotiation focused on creating mutual value while protecting your core business interests.
              </p>
            </div>
          </div>

          <div className="mt-16 bg-white p-12 rounded-2xl shadow-sm border border-gray-200">
            <h4 className="text-2xl font-bold text-gray-900 mb-8 text-center font-playfair">Key Commercial Terms We Optimize</h4>
            
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h5 className="font-semibold text-gray-900 mb-4 font-inter">Revenue Protection</h5>
                <ul className="text-gray-700 space-y-2 text-sm font-inter">
                  <li>• Payment terms and collection rights</li>
                  <li>• Price increase mechanisms</li>
                  <li>• Usage overage structures</li>
                  <li>• Currency and inflation protection</li>
                </ul>
              </div>

              <div>
                <h5 className="font-semibold text-gray-900 mb-4 font-inter">Risk Mitigation</h5>
                <ul className="text-gray-700 space-y-2 text-sm font-inter">
                  <li>• Liability caps and exclusions</li>
                  <li>• Indemnification frameworks</li>
                  <li>• Insurance requirements</li>
                  <li>• Termination and transition rights</li>
                </ul>
              </div>

              <div>
                <h5 className="font-semibold text-gray-900 mb-4 font-inter">Operational Flexibility</h5>
                <ul className="text-gray-700 space-y-2 text-sm font-inter">
                  <li>• Service modification rights</li>
                  <li>• Subcontracting permissions</li>
                  <li>• Change management processes</li>
                  <li>• Performance standard definitions</li>
                </ul>
              </div>

              <div>
                <h5 className="font-semibold text-gray-900 mb-4 font-inter">Growth Enablement</h5>
                <ul className="text-gray-700 space-y-2 text-sm font-inter">
                  <li>• Scalability provisions</li>
                  <li>• Volume discount structures</li>
                  <li>• Expansion into new markets</li>
                  <li>• Partnership development rights</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-black">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h3 className="text-4xl font-bold text-white mb-8 font-playfair">
            Ready to Optimize Your Commercial Strategy?
          </h3>
          <p className="text-xl text-gray-300 mb-12 font-inter">
            Get expert contract negotiation that protects your interests and accelerates growth.
          </p>
          <a href="/#contact" className="bg-teal-600 text-white px-12 py-4 rounded-lg text-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer inline-block font-inter">
            Schedule Consultation
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-50 text-gray-900 py-20 border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-gray-600 text-sm font-inter">
            © 2026 VTC Legal. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}